export default "__VITE_ASSET__DQQWGAL2__"